// Shown while the flyover app loads on its first launch (see lazyLaunchers.ts): fetching its chunk
// can take a moment on a slow connection, and until FlyoverPreview mounts and opens its own modal,
// with its own loading dialog, nothing else on the page responds to the tap.
export const FLYOVER_LOADING_OVERLAY_CLASS = 'flyover-lazy-loading';

// Kept up briefly after the hand-over so the modal fades in over it rather than over the page.
const HAND_OVER_MS = 300;

export function showFlyoverLoadingOverlay(doc: Document = document): () => void {
  const overlay = doc.createElement('div');
  overlay.className = FLYOVER_LOADING_OVERLAY_CLASS;
  overlay.setAttribute('aria-hidden', 'true');
  Object.assign(overlay.style, {
    position: 'fixed',
    inset: '0',
    zIndex: '2000',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'rgba(0, 0, 0, 0.5)',
  });
  const spinner = doc.createElement('div');
  spinner.className = 'spinner-border text-light';
  overlay.appendChild(spinner);
  doc.body.appendChild(overlay);

  return () => {
    setTimeout(() => overlay.remove(), HAND_OVER_MS);
  };
}
